import {
  Box,
  Button,
  Flex,
  FormLabel,
  Heading,
  HStack,
  Input,
  Stack,
  Switch,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import ReactQuill from "react-quill";
import MathQuill4Quill from 'mathquill4quill';
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import { closeCreateQuestionModel } from "../../../../modules/admin-modules/models/Actions";
import {
  createQuestionBankRequest,
  editQuestionBankRequest,
} from "../../../../modules/superadmin-modules/questions-bank/Actions";
import { getAllBucketsRequest } from "../../../../modules/superadmin-modules/bucket/Actions";
import { getAllTagsRequest } from "../../../../modules/admin-modules/tags/Actions";

import "react-quill/dist/quill.snow.css";
import katex from 'katex';
import 'katex/dist/katex.min.css';

const AddQuestion = ({ isAdd, data, setSelectedData }) => {
  const baseUrl = "https://api.agwad.net/";

  const dispatch = useDispatch();

  const [selected, setSelected] = useState("");
  const [questionAnswerImg, setQuestionAnswerImg] = useState("");

  const [answers, setAnswers] = useState([]);
  const [rightAnswer, setRightAnwser] = useState();
  const [isFiveChoices, setIsFiveChoices] = useState(false);
  const [questionType, setQuestionType] = useState(0); // 0 = MCQ, 1 = مقالي
  const [essayAnswer, setEssayAnswer] = useState("");

  const openQuestions = useSelector((state) => state.model.isOpen16);
  const buckets = useSelector((state) => state.superadminBuckets.buckets);
  const tags = useSelector((state) => state.tags.tags);
  const isLoading = useSelector((state) => state.superadminQuestionsBank.isLoading);
  useEffect(() => {
    if (openQuestions) {
      dispatch(getAllTagsRequest());
      dispatch(getAllBucketsRequest());
    }
  }, [openQuestions]);

  const bucketsOptions = buckets?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const tagsOptions = tags?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: !isAdd ? data : { difficulty_level: 0, mark: 1, type: 0 },
    shouldUnregister: true,
  });

  useEffect(() => {
    if (!isAdd && data) {
      setAnswers(data?.answers || []);
      const isEssayType = data?.type === 1;
      if (isEssayType) {
        setQuestionType(1);
        setValue("type", "1");
        setEssayAnswer(data?.answers?.[0]?.answer || "");
      } else {
        setQuestionType(0);
        setValue("type", "0");
        const filter = data?.answers
          ?.map((ans, index) => {
            if (ans?.right_answer == 1) return index;
          })
          .filter((idx) => idx != undefined);
        if (filter?.length > 0) {
          setRightAnwser(filter[0]);
        }
      }
    } else if (isAdd) {
      setAnswers([]);
      setRightAnwser(null);
      setQuestionType(0);
      setEssayAnswer("");
    }
  }, [isAdd, data, setValue]);

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة سؤال" : "تعديل  سؤال"}
      </Heading>
    </Box>
  );

  const onSubmit = async (val) => {
    let formData = new FormData();

    const values = {
      ...val,
      difficulty_level: val?.difficulty_level ? val?.difficulty_level : "0",
    };
    const keys = [
      "select",
      "answers",
      "index",
      "delete",
      "edit",
      "chapter",
      "bookmark",
      "Actions",
      "deleted_at",
      "tags",
      "defcultyLevels",
      "questionTable",
      "bucket",
      "course",
    ];
    const action = () => {
      dispatch(closeCreateQuestionModel());
      setSelectedData({});
      reset();
      setAnswers([]);
      setQuestionType(0);
      setEssayAnswer("");
    };

    const answersToSubmit = questionType === 1
      ? [{ answer: essayAnswer, right_answer: 1 }]
      : answers;

    if (isAdd) {
      answersToSubmit.map((data, idx) =>
        formData.append(`answers[${idx}][answer]`, data?.answer ?? "")
      );
      answersToSubmit.map((data, idx) =>
        formData.append(
          `answers[${idx}][right_answer]`,
          data?.right_answer ? data?.right_answer : 0
        )
      );
      values?.tags?.map((data, idx) =>
        formData.append(`tags[${idx}]`, data?.value)
      );
      for (let key in values) {
        if (!keys.includes(key) && values[key] != null)
          formData.append(key, values[key]);
      }

      const effectiveAnswers = questionType === 1 ? [{ answer: essayAnswer, right_answer: 1 }] : answers;
      const filteredAnswers = effectiveAnswers?.filter(
        (data) => data?.right_answer == 1
      );
      const expectedAnswersLength = questionType === 1 ? 1 : (isFiveChoices ? 5 : 4);
      const hasValidAnswers = questionType === 1
        ? essayAnswer?.trim?.()?.length > 0
        : effectiveAnswers?.length === expectedAnswersLength;

      if (values.bucket_id && hasValidAnswers) {
        if (questionType === 1 || filteredAnswers?.length > 0)
          await dispatch(createQuestionBankRequest(formData, action));
        else toast.error("اختر اجابة صحيحة ");
      } else {
        toast.error("  قم بمراجعة الاجابات او  اختر الفصل ");
      }
    } else {
      formData.append("_method", "PUT");
      formData.append("type", String(questionType));

      const totel = { ...data, ...values };

      const answersToSubmitEdit = questionType === 1
        ? [{ id: answers?.[0]?.id, answer: essayAnswer, right_answer: 1 }]
        : answers;

      answersToSubmitEdit.map((data, idx) => {
        if (data?.id) formData.append(`answers[${idx}][id]`, data?.id);
        formData.append(`answers[${idx}][answer]`, data?.answer ?? "");
        formData.append(`answers[${idx}][right_answer]`, data?.right_answer ? 1 : 0);
      });

      values?.tags?.map((data, idx) =>
        formData.append(`tags[${idx}]`, data?.value)
      );

      for (let key in totel) {
        if (!keys.includes(key) && key !== "type" && totel[key] != null) {
          formData.append(key, totel[key]);
        }
      }
      dispatch(
        editQuestionBankRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };
  const closeFunc = () => {
    dispatch(closeCreateQuestionModel());
    setSelectedData({});
    setAnswers([]);
    setQuestionType(0);
    setEssayAnswer("");
    reset();
  };

  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],
    ['formula'],
  
    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    [{ 'direction': 'rtl' }],                         // text direction
  
    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  
    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],
  
    ['clean']                                         // remove formatting button
  ];

  const quillRef = useRef(null);

  useEffect(() => {
    if (quillRef.current) {
      // Initialize MathQuill after the component mounts
      const enableMathQuillFormulaAuthoring = MathQuill4Quill({ Quill: ReactQuill.Quill, katex: window.katex });
      enableMathQuillFormulaAuthoring(quillRef.current.getEditor(), {
        operators: [
          ["\\sqrt{x}", "\\sqrt"],
          ["\\sqrt[n]{x}", "\\nthroot"],
          ["x^2", "^"],
          ["x_n", "_"],
          ["\\frac{x}{y}", "\\frac"],
          ["\\int_a^b", "\\int"],
          ["\\sum_{i=0}^n", "\\sum"],
        ]
      });
    }
  }, [quillRef]);

  // Make katex available globally for Quill
  window.katex = katex;

  // Register formula module if needed
  if (ReactQuill.Quill) {
    const Quill = ReactQuill.Quill;
    // Only register if not already registered
    if (!Quill.imports['formats/formula']) {
      const Formula = Quill.import('formats/formula');
      Quill.register(Formula, true);
    }
  }
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openQuestions}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex w="100%" flexWrap="wrap" justifyContent="space-between" gap="6">
          <Box w="100%" dir="rtl">
            <FormLabel>نص القطعة:</FormLabel>
            <Textarea
              name="comprehension"
              placeholder="ادخل نص القطعة التي تسبق السؤال"
              defaultValue={data?.comprehension}
              error={errors?.comprehension?.message}
              {...register("comprehension")}
            />
          </Box>
          <Box w="100%">
            <Text dir="rtl"> نص السؤال </Text>
            <ReactQuill
              ref={quillRef}
              theme="snow"
              register={register}
              name="question"
              defaultValue={data?.question}
              onChange={(val) => setValue("question", val)}
              modules={{ 
                toolbar: toolbarOptions,
                formula: true  // Enable formula module
              }}
            />
          </Box>
          <HStack w="100%" my="20px" justifyContent="space-between" dir="rtl">
            <HStack w="50%">
              <FormLabel>صورة السؤال:</FormLabel>
              <Button
                bg="main_1"
                color="white"
                borderRadius="8px"
                textAlign="center"
                position="relative"
              >
                <Text>
                  {selected
                    ? selected
                    : data?.question_image
                    ? `file_1`
                    : "اختر ملف ليتم رفعه"}
                </Text>
                <Input
                  onChange={(e) => {
                    setValue("question_image", e.target.files[0]);
                    setSelected((s) => e.target.files[0].name);
                  }}
                  type="file"
                  placeholder="اختر ملف ليتم رفعه"
                  opacity="0"
                  position="absolute"
                  w="100%"
                  h="100%"
                />
              </Button>
            </HStack>
            {data?.question_image && (
              // eslint-disable-next-line jsx-a11y/alt-text
              <img src={`${baseUrl}/${data?.question_image}`} width="200px" />
            )}
          </HStack>

          <HStack w="100%" my="20px" justifyContent="space-between" dir="rtl">
            <HStack w="50%">
              <FormLabel>صورة اجابة السؤال:</FormLabel>
              <Button
                bg="main_1"
                color="white"
                borderRadius="8px"
                textAlign="center"
                position="relative"
              >
                <Text>
                  {questionAnswerImg
                    ? questionAnswerImg
                    : data?.model_answer_image
                    ? `file_1`
                    : "اختر ملف ليتم رفعه"}
                </Text>
                <Input
                  onChange={(e) => {
                    setValue("model_answer_image", e.target.files[0]);
                    setQuestionAnswerImg((s) => e.target.files[0].name);
                  }}
                  type="file"
                  placeholder="اختر ملف ليتم رفعه"
                  opacity="0"
                  position="absolute"
                  w="100%"
                  h="100%"
                />
              </Button>
            </HStack>
            {data?.model_answer_image && (
              <img
                src={`${baseUrl}/${data?.model_answer_image}`}
                width="200px"
                alt=""
              />
            )}
          </HStack>

          <HStack
            w="100%"
            my="20px"
            justifyContent="space-between"
            dir="rtl"
            gap={4}
          >
            <Box w="50%" dir="rtl">
              {" "}
              <MainInput
                label="رابط الاجابة"
                defaultValues={data?.answer_url}
                error={errors?.answer_url?.message}
                placeholder="ادخل رابط الاجابة"
                register={register}
                name="answer_url"
                required={false}
              />
            </Box>

            <Box w="50%" dir="rtl">
              <MainInput
                label="درجة السؤال"
                defaultValues={data?.mark || 1}
                error={errors?.mark?.message}
                placeholder="ادخل درجة السؤال"
                register={register}
                name="mark"
                type="number"
                required={false}
              />
            </Box>
          </HStack>

          <HStack
            w="100%"
            my="20px"
            justifyContent="space-between"
            dir="rtl"
            gap={4}
          >
            <Box w="50%">
              <FormLabel>مجموعة الاسئلة : </FormLabel>
              <Select
                options={bucketsOptions}
                onChange={(data) => setValue("bucket_id", data.value)}
                styles={colourStyles}
                placeholder="الصف"
                defaultValue={{
                  label: data?.bucket?.name,
                  value: data?.bucket?.id,
                }}
              />
            </Box>
            <Box w="50%">
              <FormLabel> علامات الاسئلة : </FormLabel>
              <Select
                options={tagsOptions}
                isMulti
                onChange={(data) => setValue("tags", data)}
                styles={colourStyles}
                placeholder="الصف"
                defaultValue={data?.tags?.map((val) => ({
                  label: val?.name,
                  value: val?.id,
                }))}
              />
            </Box>
          </HStack>

          <Box w="100%" dir="rtl">
            <FormLabel> مستوي السؤال : </FormLabel>

            <Stack
              direction="row"
              role="group"
              aria-labelledby="my-radio-group"
              spacing="20px"
              defaultChecked={0}
            >
              <label>
                <input
                  {...register("difficulty_level")}
                  type="radio"
                  value="1"
                  defaultChecked={data?.difficulty_level == 1 ? true : false}
                />
                notes
              </label>
              <label>
                <input
                  {...register("difficulty_level")}
                  type="radio"
                  value="2"
                  defaultChecked={data?.difficulty_level == 2 ? true : false}
                />
                كتاب المدرسة
              </label>
              <label>
                <input
                  {...register("difficulty_level")}
                  type="radio"
                  value="3"
                  defaultChecked={data?.difficulty_level == 3 ? true : false}
                />
                hard questions
              </label>
              <label>
                <input
                  {...register("difficulty_level")}
                  type="radio"
                  value="4"
                  defaultChecked={data?.difficulty_level == 4 ? true : false}
                />
                امتحانات السنين السابقة
              </label>
              <label>
                <input
                  {...register("difficulty_level")}
                  type="radio"
                  value="5"
                  defaultChecked={data?.difficulty_level == 5 ? true : false}
                />
                Revision
              </label>
            </Stack>
          </Box>
          <Box w="100%" dir="rtl">
            <FormLabel mb="2">نوع السؤال : </FormLabel>
            <Stack direction="row" spacing="24px" mb="4">
              <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <input
                  {...register("type")}
                  type="radio"
                  value="0"
                  checked={questionType === 0}
                  onChange={() => setQuestionType(0)}
                />
                MCQ
              </label>
              <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <input
                  {...register("type")}
                  type="radio"
                  value="1"
                  checked={questionType === 1}
                  onChange={() => setQuestionType(1)}
                />
                مقالي
              </label>
            </Stack>
          </Box>

          <Box w="100%" dir="rtl">
            <HStack mb="10px">
              <FormLabel>الاجابات : </FormLabel>
              {questionType === 0 && (
                <HStack>
                  <input
                    type="checkbox"
                    id="fiveChoices"
                    checked={isFiveChoices}
                    onChange={(e) => setIsFiveChoices(e.target.checked)}
                  />
                  <label htmlFor="fiveChoices">5 خيارات</label>
                </HStack>
              )}
            </HStack>
            {questionType === 1 ? (
              <Box>
                <FormLabel>الإجابة النموذجية للسؤال</FormLabel>
                <Textarea
                  value={essayAnswer}
                  onChange={(e) => setEssayAnswer(e.target.value)}
                  placeholder="ادخل الإجابة النموذجية للسؤال المقالي"
                  size="md"
                  minH="120px"
                />
              </Box>
            ) : (
            [...Array(isFiveChoices ? 5 : 4)].map((val, index) => {
              return (
                <HStack my="10px">
                  <Input
                    defaultValue={
                      data?.answers?.length > 0 && !isAdd
                        ? data?.answers[index]?.answer
                        : null
                    }
                    placeholder="اضف الإجابة  "
                    size="md"
                    onChange={(e) => {
                      const newAnswers = answers;
                      newAnswers[index] = {
                        ...newAnswers[index],
                        answer: e.target.value,
                      };
                      setAnswers(newAnswers);
                    }}
                  />

                  <Switch
                    size="lg"
                    // isChecked={defaultChecked(index)}
                    isChecked={rightAnswer == index ? true : false}
                    color="#010038"
                    onChange={(e) => {
                      setRightAnwser(index);
                      let newAnswers = answers;
                      let mappedData = newAnswers?.map((val, idx) => {
                        return { ...val, right_answer: idx == index ? 1 : 0 };
                      });
                      setAnswers(mappedData);
                    }}
                  />

                  {/* {!isAdd && (
                    <Button
                      onClick={() =>
                        handelEditQuestion(data?.answers[index]?.id, index)
                      }
                    >
                      Edit
                    </Button>
                  )} */}
                </HStack>
              );
            })
            )}
          </Box>
        </Flex>
      </form>
    </MainModel>
  );
};

export default AddQuestion;
